import { BrandSpotlightBand, CollectionSpotlight, LookCard } from "@/components/marketplace"
import type { BrandSpotlightBandSection } from "@/features/feed/contract"
import { mapFeedProduct } from "@/features/feed/map-product"
import { resolveFeedLink } from "@/features/feed/resolve-link"
import { SectionFrame } from "@/features/feed/sections/SectionFrame"
import type { FeedSectionProps } from "@/features/feed/sections/types"

export const BrandSpotlightBandFeedSection = ({ section, context }: FeedSectionProps<BrandSpotlightBandSection>) => {
  const { eyebrow, title, sub, image, cta, tiles } = section.data
  const shared = {
    eyebrow,
    title,
    sub,
    image: image.url,
    imageAlt: image.alt,
    cta: cta?.label,
    ctaHref: cta ? resolveFeedLink(cta.link, context.countryCode, context.page) : undefined,
    tiles: tiles.map((tile) => mapFeedProduct(tile, context.countryCode)),
  }
  return (
    <SectionFrame section={section} context={context} gut>
      {section.presentation.variant === "looks" ? (
        <LookCard
          title={shared.title}
          label={shared.eyebrow}
          image={shared.image}
          imageAlt={shared.imageAlt}
          href={shared.ctaHref}
          tiles={shared.tiles}
          priority={context.isLeadSection}
        />
      ) : section.presentation.variant === "card" ? (
        <CollectionSpotlight {...shared} />
      ) : (
        <BrandSpotlightBand {...shared} imageTall={image.urlTall} />
      )}
    </SectionFrame>
  )
}
